<div>
  <select (change)="onFilterChange($event)" class="filter" [value]="180">
    <option value="7">Last Week</option>
    <option value="30">Last Month</option>
    <option value="180">Last 6 Months</option>
  </select>
  <canvas #lineChart></canvas>
</div>
